import { inject,Injectable } from '@angular/core';
import { TaxTypeGetRequest } from '@dave/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaxTypeEntity } from '../entities/tax-type.entity';
import { AppGatewayService } from './app-gateway.service';

@Injectable({
    providedIn: 'root',
})
export class TaxTypeDataService {
    private api = inject(AppGatewayService);

    constructor() {}

    get$(payload: TaxTypeGetRequest): Observable<TaxTypeEntity[]> {
        return this.api.Request$({ AccountingTaxTypeGet: payload }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    // return [ // todo
                    //     new TaxTypeEntity(1,null, '19%', '19% k', null, 19),
                    //     new TaxTypeEntity(2,null, 'pv', 'pv k', 'Nach § 12 Abs. 3 UStG wird keine Umsatzsteuer auf Photovoltaikanlagen ausgewiesen. ###Customer.UstId###', 0),
                    //     new TaxTypeEntity(3,null, 'rc', 'rc k', 'Nach § 13b UStG wird keine Umsatzsteuer ausgewiesen. Die Steuerschuld liegt beim Leistungsempfänger (Reverse-Charge-Verfahren).', 0),
                    // ];
                    return response.AccountingTaxTypeGet.TaxTypes.map(TaxTypeEntity.fromBackend);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }
}
